export default __webpack_public_path__ + "static/media/redirect-background.bfbd7414.jpg";